import { useState, useEffect } from 'react';
import { UserContext } from './UserContext';
import { postApi } from '../ApiServices/api';
import { apiEndPoints } from '../ApiServices/config';

const USER_STORAGE_KEY = 'devoteeData';

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const logout = () => {
    setUser(null);
  };

  const getProfile = async (data) => {
    const resposne = await postApi(apiEndPoints.getProfile, {
      user_id: data?.user_id
    });
    setUser(resposne?.data?.data);
  };

  useEffect(() => {
    const storedUser = localStorage.getItem(USER_STORAGE_KEY);
    if (storedUser) {
      getProfile(JSON.parse(storedUser));
    } else {
      setUser(null);
    }
  }, []);

  // 👇 Automatically fetch profile whenever new login data is set
  const handleSetUser = (data) => {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(data));
    getProfile(data); // fetch fresh profile
  };

  return <UserContext.Provider value={{ setUser: handleSetUser, user, logout }}>{children}</UserContext.Provider>;
};
